
export default {
  data() {
    return {
      screenWidthLgOrLarger: null,

      optionsChoice: [
        {
          name: "secondChoice",
          label:
            "Označite kvadratić ako želite prikaz sekcija za projekte (u suprotnom će se prikayat sekcije za proizvode)",
          type: "checkbox",
        },
      ],

      options: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "description",
          label: "Opis",
          type: "tipTap",
        },
        {
          name: "image",
          label: "Image",
          type: "image",
        },
        {
          name: "link",
          label: "Poveznica",
          type: "link",
        },
        {
          name: "color",
          label: "Boja pozadine #hex",
          type: "text",
        },
      ],
      optionsCategories: [
        {
          name: "category",
          label: "Kategorija",
          type: "text",
        },
      ],
      optionsProducts: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "description",
          label: "Opis",
          type: "tipTap",
        },
        {
          name: "image",
          label: "Image",
          type: "image",
        },
        {
          name: "disabled",
          label: "Nedostupno",
          type: "checkbox",
        },
        {
          name: "link",
          label: "Poveznica",
          type: "link",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(function () {
      this.checkScreenWidth();
    });
    window.addEventListener("resize", this.checkScreenWidth, {
      passive: true,
    });
  },
  methods: {
    checkScreenWidth() {
      if (window.screen && window.screen.width && window.screen.width >= 1024) {
        this.screenWidthLgOrLarger = true;
      } else this.screenWidthLgOrLarger = false;
    },
  },
};
